import { Outlet } from "react-router-dom";
import { SiteNav } from "@/components/marketing/SiteNav";
import { SiteFooter } from "@/components/marketing/SiteFooter";
import { ScrollToTop } from "@/components/ScrollToTop";
import { isNative } from "@/lib/capacitor";
import { AppFooter } from "@/components/AppFooter";

export default function MarketingLayout() {
  // The native shell uses the same routes but must retain its app-specific chrome.
  if (isNative) {
    return (
      <div className="flex min-h-dvh flex-col bg-background">
        <main className="flex-1"><Outlet /></main>
        <AppFooter />
      </div>
    );
  }

  return (
    <div className="min-h-dvh bg-background flex flex-col">
      <SiteNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <AppFooter className="mt-0 border-t bg-card" />
      <ScrollToTop />
    </div>
  );
}
